import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { fetchDeconnexion } from "../connexion/connexionSlice";
import { API_URL } from "../../Constants";

export const initialState = {
  loading: false,
  hasErrors: false,
  success: false,
  message: "",
};

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    resetPasswordStart: (state) => {
      state.loading = true;
      state.hasErrors = false;
      state.success = false;
      state.message = "";
    },
    resetPasswordSuccess: (state, { payload }) => {
      state.loading = false;
      state.hasErrors = false;
      state.success = true;
      state.message = payload.message || "Mot de passe changé avec succès !";
    },
    resetPasswordFailure: (state, { payload }) => {
      state.loading = false;
      state.hasErrors = true;
      state.success = false;
      state.message = payload.message || "Erreur lors du changement de mot de passe.";
    },
    resetPasswordClear: (state) => {
      state.loading = false;
      state.hasErrors = false;
      state.success = false;
      state.message = "";
    },
  },
});

export const {
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  resetPasswordClear,
} = resetPasswordSlice.actions;

export const resetPasswordSelector = (state) => state.resetPassword;

export default resetPasswordSlice.reducer;

export function fetchResetPassword({ id, oldPassword, newPassword }) {
  return async (dispatch, getState) => {
    dispatch(resetPasswordStart());
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": getState().connexion.utilisateur.csrf_token,
        },
        withCredentials: true,
      };

      const payload = {
        id,
        ancien_mdp: oldPassword,
        mdp: newPassword,
      };

      const response = await axios.patch(
        `${API_URL}/compte/admin/utilisateur`,
        payload,
        config
      );

      dispatch(resetPasswordSuccess(response.data));
    } catch (error) {
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.message &&
        error.response.data.message.toLowerCase().includes("ancien")
      ) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(fetchDeconnexion());
        }
        dispatch(resetPasswordFailure(error.response.data));
      } else {
        dispatch(resetPasswordFailure({ message: "Erreur réseau" }));
      }
    }
  };
}
